import React, {Fragment, useEffect, useState} from 'react';
import {connect} from "react-redux"
import {Spinner} from "react-bootstrap";
import {jsonp} from "ol/net";

import Styles from "./FormsStock.scss";


const smallCell = {
    "padding": "5px 12px",
    "fontSize": "11px"
}


const FormStock = (props)=>{

    const [entityCredits, setEntityCredits] = useState([]);
    const [prodsType, setProdsType] = useState([]);
    const [formsState, setFormsState] = useState([]);
    const [init, setInit] = useState();
    const [asData, setAsData] = useState();
    const [loading, setLoading] = useState();

    useEffect(()=>{
        (!init)?fetchEntityCredits():null;
        fetchFormsTypeCountByState();
    }, [])


    const fetchEntityCredits = ()=>{
        setLoading(true);
        axios.get('/Api/entity/credits')
            .then(result => {
                setInit(true);
                //console.log(result.data);
                (result.data && result.data.credits)?setEntityCredits(result.data['credits']):null;
                (result.data && result.data.prodsType)?setProdsType(result.data['prodsType']):null;
                (result.data && result.data.credits)?setAsData(true):null;
                setLoading(false);
            }).catch(err=>{
            setLoading(false);
        })
    }

    const fetchFormsTypeCountByState=()=>{

        axios.get('/Api/entity/forms_type/count_state')
            .then(result =>{
                setFormsState(result.data)
            })
    }


    const item = (item,index)=>{

        const testcred = _.findIndex(entityCredits, (o)=>{
            return (o.product_id == item.id)
        })
        const finalized = _.findIndex(formsState, (o)=>{
            return (o.doctype.trim().toLowerCase() == item.code.toLowerCase() && o.dem_state == 1 )
        })
        const pending = _.findIndex(formsState, (o)=>{
            return (o.doctype.trim().toLowerCase() == item.code.toLowerCase() && o.dem_state == 0 )
        })

        return (
            <tr key={index}>
                <th scope="row" className={"text-left"}>{item.code.toUpperCase()} <span style={{"fontWeight":"200"}}>- {item.title}</span></th>
                <td className={"text-primary"} style={smallCell}>
                    <span>
                    {
                        (testcred>=0)?entityCredits[testcred].cred:0
                    }
                    </span>
                </td>
                <td >
                    <span className={" badge badge-primary text-white"} style={smallCell}>
                    {(finalized>=0)?
                        formsState[finalized].total
                        :0
                    }
                    </span>
                </td>
                <td >
                   <span className={" badge badge-secondary text-white"} style={smallCell}>
                    {(pending>=0)?
                        formsState[pending].total
                        :0
                    }
                </span>
                </td>
            </tr>
        )
    }

    return (
        <div className={"card  h-100 ueThemeBackground ueColorBase"}>
            <div className={"card-body"}>
                <h5 className={"card-title"}><i className="fas fa-chart-line eu-btn-icon text-primary"></i> Formulaires</h5>
                <table className="table text-center ueColorBase ueSmallTable" >
                    <thead>
                    <tr>
                        <th scope="col">formulaires</th>
                        <th scope="col" className={smallCell}>Crédit</th>
                        <th scope="col" className={smallCell}>Finalisé</th>
                        <th scope="col" className={smallCell}>En cours</th>
                    </tr>
                    </thead>
                    <tbody>
                    {   (!loading)?
                        (asData)?(prodsType.map((e, index)=>{
                                return item(e,index)
                            }))
                            :<tr><td colSpan={4}><div className={''}><div className="text-center my-2 "><h5><i className="bi bi-exclamation-diamond text-primary"></i><br/>Pas encore de données !!</h5></div></div></td></tr>
                        :<tr><td colSpan={4}><div className={''}><div className="text-center my-2 "><Spinner animation="border" size={'sm'}/></div></div></td></tr>
                    }
                    </tbody>
                </table>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        userId: state.MeReducer.id,
        username : state.MeReducer.username,
        role : state.MeReducer.role,
    }
}

const mapDispatchTProps = dispatch => {
    return {

    }
}

export default connect(mapStateToProps, mapDispatchTProps)(FormStock);






